import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"max-width":"290"},model:{value:(_vm.showModal.show),callback:function ($$v) {_vm.$set(_vm.showModal, "show", $$v)},expression:"showModal.show"}},[_c(VCard,[_c(VCardTitle,[_vm._v("Erros:")]),_c(VCardText,[_c('ul',_vm._l((_vm.showModal.data),function(message){return _c('li',[_c('strong',[_vm._v(_vm._s(message))])])}),0)]),_c(VCardActions,[_c(VSpacer),_c(VBtn,{attrs:{"color":"error"},on:{"click":_vm.close}},[_vm._v("\n            Fechar\n        ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }